import { Box, styled } from '@mui/material';

export const ModalContent = styled(Box)(({ theme }) => ({
	display: 'flex',
	flex: 1,
	minHeight: 0,
	[theme.breakpoints.down('sm')]: {
		flexDirection: 'column',
	},
}));

export const ModalSidebar = styled(Box)(({ theme }) => ({
	width: 320,
	flexShrink: 0,
	overflowY: 'auto',
	borderRight: `1px solid ${theme.palette.divider}`,
	padding: theme.spacing(2),
	[theme.breakpoints.down('sm')]: {
		width: '100%',
		maxHeight: 220,
		borderRight: 'none',
		borderBottom: `1px solid ${theme.palette.divider}`,
	},
}));

export const ModalPreview = styled(Box)({
	display: 'flex',
	flexDirection: 'column',
	flex: 1,
	minWidth: 0,
});

export const PreviewContent = styled(Box)(({ theme }) => ({
	position: 'relative',
	flex: 1,
	minHeight: 0,
	backgroundColor: theme.palette.action.hover,
	'& iframe': {
		width: '100%',
		height: '100%',
		border: 'none',
	},
}));

export const PreviewPlaceholder = styled(Box)(({ theme }) => ({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	justifyContent: 'center',
	height: '100%',
	textAlign: 'center',
	padding: theme.spacing(4),
	gap: theme.spacing(1.5),
}));

export const PreviewActions = styled(Box)(({ theme }) => ({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	gap: theme.spacing(2),
	padding: theme.spacing(2),
	borderTop: `1px solid ${theme.palette.divider}`,
}));

export const SidebarItem = styled(Box, {
	shouldForwardProp: prop => prop !== 'isActive',
})<{ isActive: boolean }>(({ theme, isActive }) => ({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'space-between',
	gap: theme.spacing(1),
	padding: theme.spacing(1.5),
	borderRadius: 4,
	cursor: 'pointer',
	marginBottom: theme.spacing(1),
	border: `1px solid ${isActive ? theme.palette.primary.main : theme.palette.divider}`,
	backgroundColor: isActive ? theme.palette.action.selected : 'transparent',
	'&:hover': {
		backgroundColor: theme.palette.action.hover,
	},
}));
